import { useEffect, useState } from "react";
import {
  readStoredTimeZone,
  resolveDisplayTimeZone,
  type DisplayTimeZone,
} from "@/lib/display-preferences";

export function useTimeZonePreference(): DisplayTimeZone {
  const [timeZone, setTimeZone] = useState<DisplayTimeZone>(readStoredTimeZone);

  useEffect(() => {
    const sync = () => setTimeZone(readStoredTimeZone());
    window.addEventListener("timezonechange", sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener("timezonechange", sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  return timeZone;
}

export function useDisplayTimeZone(): string {
  return resolveDisplayTimeZone(useTimeZonePreference());
}
